
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-06-03-r3f-multiple-views",
      function () {
        return require("private-next-pages/blogs/2025-06-03-r3f-multiple-views/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-06-03-r3f-multiple-views"])
      });
    }
  